import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { advisor } from 'src/models/advisor';
import { APIServiceAdvisorBlockedSchedule } from 'src/services/api-services/api-advisor-blocked-schedule-service';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { AdvisorsComponent } from '../../advisors.component';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-delete-workshop',
    templateUrl: './delete-advisor.dialog.html',
    styleUrls: ['./delete-advisor.dialog.sass'],
    standalone: false
})
export class DeleteadvisorDialog {
  public test: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<AdvisorsComponent>,
    @Inject(MAT_DIALOG_DATA) public advisor: advisor,
    public ServiceAdvisorApi: APIServiceAdvisorService,
    public helperService: HelperService,
    public AdvisorBlockedScheduleService: APIServiceAdvisorBlockedSchedule,
    private translate: TranslateService
  ) {}

  isError = false;
  eventReassignment: string = '';
  serviceDealer: any;
  bloquedAdvisor: any;

  ngOnInit(): void {
    this.getServiceAdvisorBlockedSchedule();
  }

  getServiceAdvisorBlockedSchedule() {
    let id = sessionStorage.getItem('ServiceAdvisorBlockedSchedule') || '';
    this.AdvisorBlockedScheduleService?.get(id).subscribe({
      next: (response: any) => {
        this.bloquedAdvisor = response.filter(
          (s) => s.advisorId === this.advisor.advisorId
        );
      },
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    });
  }

  onSaveDisable(): void {
    if (this.advisor.isActive === true) {
      this.advisor.isActive = false;
    }
    // if(this.advisor.email=== ""){this.advisor.email= this.advisor.workshopName+"@" }
    this.ServiceAdvisorApi?.put(this.advisor)
      .pipe(
        finalize(() => {
          this.dialogRef.close('DeleteData');
          const translateText = this.translate.instant(
            'ToastAdvisorDisabled',
            {
              fullName:this.advisor.advisorName,
            }
          );
          this.helperService.showAlert =true
          this.helperService.typeAlert ="success"
          this.helperService.messageAlert =translateText
          setTimeout(() => {
            this.helperService.showAlert =false
          }, 7000)
        })
      )
      .subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
  }

  onSave(): void {
    this.isError = true;
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
